import React, { useState } from 'react';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/delete.svg';
import { ReactComponent as Close } from '../../../../assets/images/teamclose.svg';
import { Box, Typography } from '@mui/material';
import { deleteKbCategory } from '../../../../store/features/deleteKbCategory';
import { useDispatch } from 'react-redux';
import { getAllKbCategories } from '../../../../store/features/getCategoriesToKnowledgeBase';

function DeleteCategoryPopUp(props) {
  const {
    open,
    category, // Optional: for personalized message
    onDelete,
    onClose,
    groupId,
  } = props;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  if (!open) {
    return null; // Don't render when closed (efficient, no DOM pollution)
  }

  const handleDelete = async () => {
    if (!category?.id) {

      return;
    }

    setIsLoading(true);

    try {
      await dispatch(deleteKbCategory({ categoryId: category.id, group_id: groupId })).unwrap();
      await dispatch(getAllKbCategories({ group_id: groupId })).unwrap();
      // On success, close the popup and optionally notify parent
      if (onClose) onClose();
      if (onDelete) onDelete(); // Call parent's handler if provided (e.g., local state update)
    } catch (error) {
      onClose()
      // Error is handled by the thunk's rejected case with toast

    } finally {
      setIsLoading(false);

    }
  };

  const handleCancel = () => {
    if (onClose) onClose(); // Close without deleting
  };

  const categoryName = category?.title || 'this category'; // Fallback if no category passed

  return (
    <>
      <div
        className="overlay"
        style={{
          display: 'block', // Ensure visible when open
          opacity: open ? 1 : 0, // Optional: Fade effect (add transition in CSS)
          transition: 'opacity 0.2s ease-in-out'
        }}
        onClick={handleCancel} // Click outside to cancel (optional enhancement)
      />
      <div style={{ top: '25%' }} className="Team-PopUp-Container">
        <div className="Team-PopUp-Header-Group">
          <p className="PopUp-Text02" onClick={handleCancel}>
            <Close />
          </p>
        </div>

        <Box
          sx={{
            mt: '-18px !important', // MUI sx supports !important via the `!important` suffix
            // Add other styles if needed, e.g., display: 'block'
          }}
          className="Delete-group-container"
        >
          <DeleteIcon />
          <p className="DeleteFile-text">Delete Category</p>
          <Typography sx={{
            color: '#556575',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            marginTop: '8px',
            lineHeight: '20px',
          }}>
            Are you sure you want to delete {categoryName}? All articles in this category will be uncategorized.
          </Typography>
        </Box>
        <div className="Deletegroup-delete-container">
          <button
            style={{ width: '176px' }}
            className="Deletegroup-cancel01"
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            style={{ width: '176px' }}
            className="Deletegroup-delete01"
            onClick={handleDelete}
            type="button"
            disabled={isLoading}
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </>
  );
}

export default DeleteCategoryPopUp;